<template>
  <div v-if="(rtspData.length > 0) || userData.groupname === 'psd'">
    <div>
      <b-row>
        <b-col
          lg="6"
          md="6"
          sm="6"
        >
          <span style="color:white; text-align: left; font-size:24px;">
            <svg
              width="40"
              height="46"
              viewBox="0 0 40 46"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="2"
                y="25.2727"
                width="3.88746"
                height="8.72727"
                rx="0.5"
                fill="url(#paint0_linear_373_9985)"
              />
              <path
                d="M6.85938 28.1819H8.3031C8.57925 28.1819 8.8031 28.4057 8.8031 28.6819V31.5607C8.8031 31.8368 8.57925 32.0607 8.3031 32.0607H6.85938V28.1819Z"
                fill="url(#paint1_linear_373_9985)"
              />
              <path
                d="M29.5701 16.5454L30.9266 17.038C31.1862 17.1323 31.3199 17.419 31.2252 17.6784L29.9059 21.2951C29.8113 21.5545 29.5242 21.6884 29.2646 21.5941L27.9081 21.1015L29.5701 16.5454Z"
                fill="url(#paint2_linear_373_9985)"
              />
              <path
                d="M19.0076 20.4243L18.8857 20.8781C18.8141 21.1448 18.5398 21.3032 18.273 21.2318L14.5453 20.2352C14.2785 20.1639 14.1203 19.8899 14.192 19.6232L14.3138 19.1694L19.0076 20.4243Z"
                fill="url(#paint3_linear_373_9985)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.0834 21.896L15.2059 21.394L13.0877 29.1516H9.7749V31.091H13.6624L13.6624 31.091L14.6343 31.091L17.0834 21.896Z"
                fill="url(#paint4_linear_373_9985)"
              />
              <path
                d="M7.62427 6.84839L29.5424 14.8081L27.0049 21.7641C26.9103 22.0235 26.6232 22.1574 26.3636 22.0632L6.79537 14.9568C5.75714 14.5797 5.22235 13.4329 5.60088 12.3952L7.62427 6.84839Z"
                fill="url(#paint5_linear_373_9985)"
              />
              <path
                d="M8.47419 3.88249C8.85323 2.8434 10.0041 2.30806 11.043 2.6876L33.9828 11.0681L29.9538 13.4821C29.8245 13.5596 29.6672 13.5747 29.5255 13.5233L7.8313 5.64487L8.47419 3.88249Z"
                fill="url(#paint6_linear_373_9985)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_373_9985"
                  x1="3.94373"
                  y1="25.2727"
                  x2="3.94373"
                  y2="34"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#B5C1FF" />
                  <stop
                    offset="1"
                    stop-color="#004CEC"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_373_9985"
                  x1="7.83124"
                  y1="28.1819"
                  x2="7.83124"
                  y2="32.0607"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#B5C0FF" />
                  <stop
                    offset="1"
                    stop-color="#1D56AC"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_373_9985"
                  x1="30.4833"
                  y1="16.8771"
                  x2="28.8279"
                  y2="21.4355"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#B5C1FF" />
                  <stop
                    offset="1"
                    stop-color="#004CEC"
                  />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_373_9985"
                  x1="17.5"
                  y1="19"
                  x2="16.4972"
                  y2="21.4989"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#B5C0FF" />
                  <stop
                    offset="1"
                    stop-color="#004CEC"
                  />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_373_9985"
                  x1="13.4291"
                  y1="21.394"
                  x2="13.4291"
                  y2="31.091"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#B5C1FF" />
                  <stop
                    offset="1"
                    stop-color="#004CEC"
                  />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_373_9985"
                  x1="18.5833"
                  y1="10.8283"
                  x2="15.8852"
                  y2="18.2578"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#B5C0FF" />
                  <stop
                    offset="1"
                    stop-color="#004CEC"
                  />
                </linearGradient>
                <linearGradient
                  id="paint6_linear_373_9985"
                  x1="21.5805"
                  y1="6.51027"
                  x2="20.2561"
                  y2="10.157"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#B5C0FF" />
                  <stop
                    offset="1"
                    stop-color="#1D56AC"
                  />
                </linearGradient>
              </defs>
            </svg>
            <span v-if="userData.department === '0'">กล้องวงจรปิด (ทั่วประเทศ)</span>
            <span v-else>กล้องวงจรปิด</span>
          </span>
        </b-col>
        <b-col
          lg="6"
          md="6"
          sm="6"
          class="text-sm-right"
        >
          <b-link to="/cctv-total">
            <span style="text-align: right; color: #00B058; font-size:20px; text-decoration: underline;">
              ดูเพิ่มเติม
            </span>
            <feather-icon
              size="30"
              icon="ChevronRightIcon"
              style="color: #00B058; margin-bottom: 3px;"
            />
          </b-link>
        </b-col>
      </b-row>
    </div>

    <!-- กล้องวงจรปิด -->
    <b-row>
      <b-col
        lg="12"
        md="12"
        sm="12"
      >
        <b-row>
          <b-col
            v-for="(link, index) in rtsp.slice(0, 4)"
            :key="index"
            lg="6"
            md="6"
            sm="12"
          >
            <div class="container">
              <VideoPlayer
                :source="link"
                class="mt-2"
                @video-error="handleVideoError(index)"
              />
              <b-card-text>
                <span style="color: white;">{{ name[index] }}</span>
              </b-card-text>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BLink, BCardText,
} from 'bootstrap-vue'
import axios from '@axios'
import VideoPlayer from './VideoPlayer.vue'

export default {
  name: 'CCTVDisplay',
  components: {
    BRow,
    BCol,
    BLink,
    BCardText,
    VideoPlayer,
  },
  data() {
    return {
      rtspData: [],
      rtsp: [],
      name: [],
      ISOnline: [],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getRTSPCCTV()
    this.interval = setInterval(() => {
      this.getRTSPCCTV()
    }, 300000)
  },
  methods: {
    async getRTSPCCTV() {
      try {
        const response = await axios.post('/getCCTVTotalDB', {
          department: this.userData.department,
          owner: this.userData.groupname,
          username: this.userData.username,
        })
        this.rtspData = response.data
        this.rtsp = this.rtspData.map(value => value.RTSP_HLS)
        this.name = this.rtspData.map(value => value.Camera_Desc)
        this.ISOnline = this.rtspData.map(value => value.ISOnline)
      } catch (error) {
        console.log(error)
      }
    },
    handleVideoError(index) {
      console.log(`Video error at index ${index}`)
      // ปรับสถานะเป็น Offline เมื่อไม่สามารถโหลดวิดีโอได้
      if (this.ISOnline && this.ISOnline[index] === 'Online') {
        this.$set(this.ISOnline, index, 'Offline')
      }

      // ลองโหลดข้อมูลใหม่หลังจาก 30 วินาที
      setTimeout(() => {
        this.getRTSPCCTV()
      }, 30000)
    },
  },
}
</script>
